export type IdealRateInputs = {
	startDate: Date;
	scope: number;
	endDate: Date;
};

/**
 * Calculates the guideline for the burnup. This should be moved to SWAG in a future iteration.
 */
export const calculateIdealWorkRate = (inputs: IdealRateInputs): [string, number][] => {
	const { startDate, scope, endDate } = inputs;

	return [
		[startDate.toISOString(), 0],
		[endDate.toISOString(), scope],
	];
};
